/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_RateInputs */

const en_form_rate = /** @type {(inputs: Form_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate (per hour)`)
};

const he_form_rate = /** @type {(inputs: Form_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תעריף (לשעה)`)
};

/**
* | output |
* | --- |
* | "Rate (per hour)" |
*
* @param {Form_RateInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_rate = /** @type {((inputs?: Form_RateInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_RateInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_rate(inputs)
	return he_form_rate(inputs)
});